import { SiafLiteApiStream } from "../../external";
import SiafLiteApiRepository from "../../external/siafLiteApi";
import store from "../../config/store";
class CaixaService {
  constructor() {
    this.urlBase = "financeiro/caixa";
    this.urlBaseEvent = `/event/${this.urlBase}`;
    this.urlBaseCompleta = `${store.baseUrl}/${this.urlBase}`;
  }

  getRelatorios(data, bancoCaixaId, filter) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${data}/${bancoCaixaId}/relatorios`,
    ).get(filter);
  }

  getRelatorioIntervalo(data, bancoCaixaId, filter) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${data}/${bancoCaixaId}/relatorios-intervalos`,
    ).get(filter);
  }

  getTotaisDia(data, bancoCaixaId, filter) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${data}/${bancoCaixaId}/totais`,
    ).get(filter);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  caixaAberto(data, bancoCaixaId, empresaId) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${data}/${bancoCaixaId}/aberto`,
    ).get(empresaId ? { empresaId } : undefined);
  }

  movimentar(id, movimentacaoCaixa) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/movimentar`,
    ).post(movimentacaoCaixa);
  }

  getRelatorioDetalhado(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/detalhado`,
    ).path(body);
  }

  tranferirSaldo(movimentacaoCaixa) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/transferir-saldo`,
    ).post(movimentacaoCaixa);
  }

  removerTransferenciaSaldo(codigo) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/remover-transferencia-saldo/${codigo}`,
    ).patch();
  }

  removerSuprimento(codigo) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/remover-suprimento/${codigo}`,
    ).patch();
  }

  removerSangria(codigo) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/remover-sangria/${codigo}`,
    ).patch();
  }

  getRelatorioFluxoCaixa(filtros) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/estatistica/relatorio-fluxo-caixa-grafico`,
    ).patch(filtros);
  }

  gerarPdf(filtros) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/estatistica/gerar-pdf-fluxo-caixa`,
    ).patch(filtros);
  }
}

export default CaixaService;
